// 监控
import React, { useState, useEffect } from "react";
import { Modal, DatePicker, ConfigProvider, message, Tabs } from "antd";
import { dateFormat, sizeTostr } from "../../../utils";
import BoxServe from "../../../ajax/api/index";
import ReactEcharts from "echarts-for-react";

import zhCN from "antd/es/locale/zh_CN"; // 引入语言包
import moment from "moment";
import dayjs from "dayjs";
import "moment/locale/zh-cn";
moment.locale("zh-cn"); // 注意这里设置 moment 必须放在有 import 的后面。

const dateF = "YYYY-MM-DD";

// 默认显示前三天日期可选
const disabledDate = (current) => {
  const starDate = moment().subtract(15, "days");
  const endDate = moment().subtract(0, "day");
  return current > endDate || current < starDate;
};

// 提示信息

export default function MonitorModel(props) {
  const tabsList = [
    {
      key: "1",
      label: "跑量",
    },
    {
      key: "2",
      label: `内存(${props.dataObj.memTotal})`,
    },
    {
      key: "3",
      label: `系统(${props.dataObj.coreNum}核)`,
    },
    {
      key: "4",
      label: `存储(${props.dataObj.storageTotalSize})`,
    },
  ];
  const [defaultDate] = useState(dayjs(dateFormat(new Date(), dateF), dateF));
  const [valueDate, setValueDate] = useState(dayjs(dateFormat(new Date(), dateF), dateF));
  const [option, setOption] = useState({}); // 跑量
  const [checdDate] = useState(dateFormat(new Date(), dateF)); //
  const [timer, setTimer] = useState(null);

  const [innerWidth, setInnerWidth] = useState(1000);

  const [tabsActive, setTabsActive] = useState("1");
  const [optionCpu, setOptionCpu] = useState({}); // 系统
  const [optionMem, setOptionMem] = useState({}); // 内存
  const [optionStorage, setOptionStorage] = useState({}); // 存储
  const [scorepoints, setScorepoints] = useState(0); // 打点数

  // 获取跑量数据
  const getTflowLists = async (dateStr) => {
    const params = {
      deviceId: props.dataObj.deviceId,
      searchDate: dateStr ? dateStr : checdDate,
      limit: 1000,
    };
    try {
      const { code, data = [], count = 0 } = await BoxServe.getTflowList(params);
       setScorepoints(count);
      if (String(code) === "0") {
        return {
          code: "0",
          data,
        };
       
      } else {
        return {
          code,
          data: "错误！",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        code: "err",
        data: error.message || error.msg,
      };
    }
  };

  // 跑量数据过滤
  const getData = async (dateStr) => {
    const { code, data = [] } = await getTflowLists(dateStr);
    if (code !== "0" || code === "err") {
      clearInterval(timer);
      return message.error(data);
    }

    data?.reverse();

    let timeList =
      data?.map((item) => {
        return dateFormat(item.createTime, "HH:mm");
      }) || [];

    // UP 数据
    let upList = data?.map((item) => (item.up ? sizeTostr(item.up, 2) : 0)) || [];

    // down 数据
    let downList = data?.map((item) => (item.down ? sizeTostr(item.down, 2) : 0)) || [];
    // setList(data)

    const op = {
      grid: {
        left: "2%",
        right: "3%",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["up", "down"],
        bottom: 0,
      },
      xAxis: {
        name: "时间",
        type: "category",
        nameLocation: "end",
        data: timeList,
        axisLabel: {
          //展示角度
          // rotate: 60,
          interval: "auto",
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        name: "单位(Mb)",
        type: "value",
      },
      series: [
        {
          name: "up",
          data: upList,
          type: "line",
          showSymbol: false,
          // smooth: true // 线条平滑
        },
        {
          name: "down",
          data: downList,
          type: "line",
          showSymbol: false,
          lineStyle: {
            normal: {
              color: "#FA6F53",
            },
          },
          // smooth: true // 线条平滑
        },
      ],
    };
    setOption(op);
  };

  // 跑量定时
  const onChange = (date, dateString) => {
    clearInterval(timer);
    setValueDate(date);
    switch (tabsActive) {
      case "1": // 跑量
        if (dateString === dateFormat(new Date(), dateF)) {
          getData(null);
          const timeOut = setInterval(() => {
            getData(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          return () => clearInterval(timer);
        } else {
          clearInterval(timer);
          getData(dateString);
        }
        break;
      case "2": // 内存
        if (dateString === dateFormat(new Date(), dateF)) {
          filterPageMemList(null);
          const timeOut = setInterval(() => {
            filterPageMemList(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          return () => clearInterval(timer);
        } else {
          clearInterval(timer);
          filterPageMemList(dateString);
        }
        break;

      case "3": // 系统
        if (dateString === dateFormat(new Date(), dateF)) {
          filterPageCpuList(null);
          const timeOut = setInterval(() => {
            filterPageCpuList(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          return () => clearInterval(timer);
        } else {
          clearInterval(timer);
          filterPageCpuList(dateString);
        }

        break;
      case "4": // 存储
        if (dateString === dateFormat(new Date(), dateF)) {
          filterPageStorageList(null);
          const timeOut = setInterval(() => {
            filterPageStorageList(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          return () => clearInterval(timer);
        } else {
          clearInterval(timer);
          filterPageStorageList(dateString);
        }
        break;
      default: // 无匹配默认跑量
        if (dateString === dateFormat(new Date(), dateF)) {
          getData(null);
          const timeOut = setInterval(() => {
            getData(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          return () => clearInterval(timer);
        } else {
          clearInterval(timer);
          getData(dateString);
        }
        break;
    }
    // if (dateString === dateFormat(new Date(), dateF)) {
    //   getData(null);
    //   const timeOut = setInterval(() => {
    //     getData(null);
    //   }, 180000); // 三分钟请求一次
    //   setTimer(timeOut);
    //   return () => clearInterval(timer);
    // } else {
    //   clearInterval(timer);
    //   getData(dateString);
    // }
  };

  // 获取系统数据
  const getPageCpuList = async (dateStr) => {
    const params = {
      deviceNoList: props.dataObj.deviceNo,
      startDate: dateStr ? dateStr + " 00:00:00" : checdDate + " 00:00:00",
      endDate: dateStr ? dateStr + " 23:59:59" : dateFormat(new Date(), "YYYY-MM-DD HH:mm:ss"),
      page: 1,
      limit: 1000,
    };
    try {
      const { code, data } = await BoxServe.getPageCpuList(params);
      if (String(code) === "0") {
        return {
          code: "0",
          data,
        };
      } else {
        return {
          code,
          data: "错误！",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        code: "err",
        data: error.message || error.msg,
      };
    }
  };

  // 系统数据过滤
  const filterPageCpuList = async (dateStr) => {
    const { code, data = [] } = await getPageCpuList(dateStr);
    if (code !== "0" || code === "err") {
      clearInterval(timer);
      return message.error(data);
    }
    data?.reverse();

    let timeList =
      data?.map((item) => {
        return dateFormat(item.createTime, "HH:mm");
      }) || [];

    // UP 数据
    let upList = data?.map((item) => item.cpu) || [];

    const op = {
      grid: {
        left: "2%",
        right: "3%",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["up", "down"],
        bottom: 0,
      },
      xAxis: {
        name: "时间",
        type: "category",
        nameLocation: "end",
        data: timeList,
        axisLabel: {
          //展示角度
          // rotate: 60,
          interval: "auto",
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        name: "单位(核)",
        type: "value",
        min: 0,
        max: props.dataObj.coreNum,
      },
      series: [
        {
          name: "系统负载",
          data: upList,
          type: "line",
          showSymbol: false,
          // smooth: true // 线条平滑
        },
      ],
    };
    setOptionCpu(op);
  };

  // 获取内存数据
  const getPageMemList = async (dateStr) => {
    const params = {
      deviceNoList: props.dataObj.deviceNo,
      startDate: dateStr ? dateStr + " 00:00:00" : checdDate + " 00:00:00",
      endDate: dateStr ? dateStr + " 23:59:59" : dateFormat(new Date(), "YYYY-MM-DD HH:mm:ss"),
      page: 1,
      limit: 1000,
    };
    try {
      const { code, data } = await BoxServe.getPageMemList(params);
      if (String(code) === "0") {
        return {
          code: "0",
          data,
        };
      } else {
        return {
          code,
          data: "错误！",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        code: "err",
        data: error.message || error.msg,
      };
    }
  };
  // 内存数据过滤
  const filterPageMemList = async (dateStr) => {
    const { code, data = [] } = await getPageMemList(dateStr);
    if (code !== "0" || code === "err") {
      clearInterval(timer);
      return message.error(data);
    }
    data?.reverse();

    let timeList =
      data?.map((item) => {
        return dateFormat(item.createTime, "HH:mm");
      }) || [];

    // UP 数据
    let upList = data?.map((item) => item.mem * 100) || [];

    const op = {
      grid: {
        left: "2%",
        right: "3%",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["up", "down"],
        bottom: 0,
      },
      xAxis: {
        name: "时间",
        type: "category",
        nameLocation: "end",
        data: timeList,
        axisLabel: {
          //展示角度
          // rotate: 60,
          interval: "auto",
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        name: `内存使用率(%)`,
        type: "value",
        min: 0,
        max: 100,
      },
      series: [
        {
          name: "内存使用率(%)",
          data: upList,
          type: "line",
          showSymbol: false,
          // smooth: true // 线条平滑
        },
      ],
    };
    setOptionMem(op);
  };

  // 获取存储数据
  const getPageStorageList = async (dateStr) => {
    const params = {
      deviceNoList: props.dataObj.deviceNo,
      startDate: dateStr ? dateStr + " 00:00:00" : checdDate + " 00:00:00",
      endDate: dateStr ? dateStr + " 23:59:59" : dateFormat(new Date(), "YYYY-MM-DD HH:mm:ss"),
      page: 1,
      limit: 1000,
    };
    try {
      const { code, data } = await BoxServe.getPageStorageList(params);
      if (String(code) === "0") {
        return {
          code: "0",
          data,
        };
      } else {
        return {
          code,
          data: "错误！",
        };
      }
    } catch (error) {
      console.log(error);
      return {
        code: "err",
        data: error.message || error.msg,
      };
    }
  };

  // 存储数据过滤
  const filterPageStorageList = async (dateStr) => {
    const { code, data = [] } = await getPageStorageList(dateStr);
    if (code !== "0" || code === "err") {
      clearInterval(timer);
      return message.error(data);
    }
    data?.reverse();

    let timeList =
      data?.map((item) => {
        return dateFormat(item.createTime, "HH:mm");
      }) || [];

    // UP 数据
    let upList = data?.map((item) => item.storage * 100) || [];

    const op = {
      grid: {
        left: "2%",
        right: "3%",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["up", "down"],
        bottom: 0,
      },
      xAxis: {
        name: "时间",
        type: "category",
        nameLocation: "end",
        data: timeList,
        axisLabel: {
          //展示角度
          // rotate: 60,
          interval: "auto",
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        name: "存储使用率(%)",
        type: "value",
        min: 0,
        max: 100,
      },
      series: [
        {
          name: "存储使用率(%)",
          data: upList,
          type: "line",
          showSymbol: false,
          // smooth: true // 线条平滑
        },
      ],
    };
    setOptionStorage(op);
  };

  useEffect(() => {
    let timeOut = null;
    if (props.dataObj.monitorVisible) {
      setValueDate(dayjs(dateFormat(new Date(), dateF), dateF));
      clearInterval(timer);
      switch (tabsActive) {
        case "1": // 跑量
          getData(null);
          timeOut = setInterval(() => {
            getData(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          break;
        case "2": // 内存
          filterPageMemList(null);
          timeOut = setInterval(() => {
            filterPageMemList(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          break;

        case "3": // 系统
          filterPageCpuList(null);
          timeOut = setInterval(() => {
            filterPageCpuList(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          break;
        case "4": // 存储
          filterPageStorageList(null);
          timeOut = setInterval(() => {
            filterPageStorageList(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
          break;
        default: // 无匹配默认跑量
          getData(null);
          timeOut = setInterval(() => {
            getData(null);
          }, 180000); // 三分钟请求一次
          setTimer(timeOut);
      }
    } else {
      clearInterval(timer);
    }
  }, [props.dataObj.monitorVisible, tabsActive]);

  // 日期选择

  // 关闭弹框
  const onCancel = () => {
    props.handleMonitorModelClose(false);
  };

  // 获取当前可是区域宽度，赋值给图表
  const echartsReact = (e) => {
    setInnerWidth(window.innerWidth);
  };

  // tabs 切换
  const tabsChange = (key) => {
    setValueDate(dayjs(dateFormat(new Date(), dateF), dateF));
    setTabsActive(key);
  };

  return (
    <>
      <div style={{ width: "80%" }}>
        <Modal title="监控" width="80%" footer={null} open={props.dataObj.monitorVisible} onCancel={onCancel} wrapClassName="monitor-modal">
          <div className="monitor-content">
            <span className="title">设备号：{props.dataObj.deviceNo}</span>
            <div className="date-p">
              <ConfigProvider locale={zhCN}>
                <DatePicker onChange={onChange} defaultValue={defaultDate} value={valueDate} disabledDate={disabledDate} allowClear={false} />
              </ConfigProvider>
            </div>
            <span className="score-points">打点数：{scorepoints}</span>
            <Tabs defaultActiveKey="1" items={tabsList} onChange={tabsChange} />
            {tabsActive === "1" ? (
              <ReactEcharts
                option={option}
                className="main-echarts"
                ref={echartsReact}
                autoResize={true}
                notMerge={true}
                // onEvents={{resize: handleChartResize}} // 加上每次数据渲染都会重绘，有闪烁
                style={{ height: "700px", width: innerWidth * 0.75 + "px" }}
              />
            ) : tabsActive === "2" ? (
              //   内存
              <div>
                {/* <span>内存：{props.dataObj.memTotal}</span> */}
                <ReactEcharts
                  option={optionMem}
                  className="main-echarts"
                  ref={echartsReact}
                  autoResize={true}
                  notMerge={true}
                  // onEvents={{resize: handleChartResize}} // 加上每次数据渲染都会重绘，有闪烁
                  style={{ height: "700px", width: innerWidth * 0.75 + "px" }}
                />
              </div>
            ) : tabsActive === "3" ? (
              //   系统
              <ReactEcharts
                option={optionCpu}
                className="main-echarts"
                ref={echartsReact}
                autoResize={true}
                notMerge={true}
                // onEvents={{resize: handleChartResize}} // 加上每次数据渲染都会重绘，有闪烁
                style={{ height: "700px", width: innerWidth * 0.75 + "px" }}
              />
            ) : (
              //   存储
              <ReactEcharts
                option={optionStorage}
                className="main-echarts"
                ref={echartsReact}
                autoResize={true}
                notMerge={true}
                // onEvents={{resize: handleChartResize}} // 加上每次数据渲染都会重绘，有闪烁
                style={{ height: "700px", width: innerWidth * 0.75 + "px" }}
              />
            )}
          </div>
        </Modal>
      </div>
    </>
  );
}

// export default MonitorModel
